export enum OBJECT_BLOCK_VARIANT {
    OVERVIEW = 'overview',
    PREVIEW = 'preview',
    LINKED = 'linked',
}
